import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getNewOpenMarketProduct } from '../../../../api/product/queries/getNewOpenMarketProduct';
import { INewOpenMarketProduct } from '../../../../interfaces/OpenMarketProduct.interfaces';

export const useGetNewOpenMarketProductQuery = () => {
  return useQuery<INewOpenMarketProduct, AxiosError, INewOpenMarketProduct>(
    ['user-sell-tractors/new-tractor'],
    () => getNewOpenMarketProduct(),
    {
      select: (data: INewOpenMarketProduct) => {
        return {
          ...data,
          startOnSaleDate: data.approvalDate,
        };
      },
    },
  );
};
